import { render, staticRenderFns } from "./SysTeacherAudio.vue?vue&type=template&id=7f59f205&scoped=true"
import script from "./SysTeacherAudio.vue?vue&type=script&lang=js"
export * from "./SysTeacherAudio.vue?vue&type=script&lang=js"
import style0 from "./SysTeacherAudio.vue?vue&type=style&index=0&id=7f59f205&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f59f205",
  null
  
)

export default component.exports